import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ZeroProjectUpdate,
  ZeroProjectWithRelations,
} from "@/hooks/useProjects";
import { ProjectForm } from "@/components/forms/ProjectForm";
import { ProjectContactsSection } from "./ProjectContactsSection";

interface ProjectGeneralTabProps {
  project: ZeroProjectWithRelations;
  onUpdate: (updates: ZeroProjectUpdate) => void;
  isUpdating: boolean;
  isReadOnly?: boolean;
  readOnlyReason?: string | null;
}

export function ProjectGeneralTab({
  project,
  onUpdate,
  isUpdating,
  isReadOnly = false,
  readOnlyReason,
}: ProjectGeneralTabProps) {
  const handleSubmit = (data: ZeroProjectUpdate) => {
    onUpdate(data);
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Project Settings</CardTitle>
        </CardHeader>
        <CardContent>
          <ProjectForm
            project={project}
            onSubmit={handleSubmit}
            isLoading={isUpdating}
            disabled={isReadOnly}
            disabledReason={readOnlyReason}
          />
        </CardContent>
      </Card>

      <ProjectContactsSection
        projectId={project.id}
        customerId={project.customerID ?? null}
      />
    </div>
  );
}
